const FINANCIAL_DATA_EDIT_LINK_PROPS = {
  iconConfiguration: {
    icon: 'icon_symbols_edit',
    height: '20px',
    width: '20px',
  },
  href: '#',
  iconPosition: 'LEFT',
  textVariant: 'FONT_PARAGRAPH_250',
  type: 'PRIMARY',
};

export { FINANCIAL_DATA_EDIT_LINK_PROPS };
